/* eslint-disable array-callback-return */
/* 发布商品-填写信息 */
import React, { Component, Fragment } from "react";
import {
  Steps,
  Table,
  Radio,
  Input,
  Button,
  message,
  Upload,
  Spin,
  Select, Modal,
  Space,
  Tooltip
} from "antd";
import { LoadingOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  IconFont,
  history,
  API,
  ROOT,
  imgRoot,
  Keys,
} from "../../../static/js/common";
import proArea from "../../../static/json/province.json";
import cityArea from "../../../static/json/city.json";
import countyArea from "../../../static/json/county.json";
import { withRouter } from 'react-router-dom';
import {CopyToClipboard} from "react-copy-to-clipboard";
const { Search } = Input;

const antIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />;

const { Step } = Steps;

const { TextArea } = Input;

const { Dragger } = Upload;

const { Option } = Select;



// 文件格式大小验证
function beforeUpload(file) {
  /*   const isFile = /csv|excel|sheet/g.test(file.type);
  if (!isFile) {
    message.error("仅支持CSV、XLSX、XLS格式的文件！");
  } */
 
  const isLt1M = file.size / 1024 / 1024 < 5;
  if (!isLt1M) {
    message.error("上传的文件不能大于5MB!");
  }
  return isLt1M;
}

class GoodsInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goods_info: [],
      inputType: 1,
      dataPlatform: "",
      isBtn1Disabled:true,
      receiver_info: "",
      sendName: "", //发件人姓名
      sendMobile: "", //发件人手机号
      receiver_list: [],
      update_list: [], // 编辑收货人信息备份列表
      goodsId: this.props.location.search
        ? this.props.location.search.slice(1)
        : "",
      remark: "",
      up_loading: false, // 文件上传
      file_url: "",
      platform: ["1", "2", "3", "4"],
      loading: false,
      orderStatus: 0,
      btnDisabled: false,
      saveLoading: false,
      isAuth: 0,
      isShowAuth: false,
      isShowOver:false,
      isModalOpen: false,
      isModalLiOpen: false,
      liMessage:"",
      addressData:[],
      selectedOrderSn: [],
      data:[],
      shopType:null,
      pddLoading:false,
      currentUser:null,
      pddValue:6,
      tbValue:'6',
      dyValue:6,
      overAt:null,
      isOverValue:null,
      overLoading:false,
      isDyIdModalOpen:false,
      dyShopId:"",
    };
    this.saveReceiverInfo = this.debounce(this.saveReceiverInfo,300)
  }

  componentDidMount() {
    const { goodsId } = this.state;
    if (goodsId) {
      API.getGoodsInfo({ goodsId }).then((res) => {
        if (res.status * 1 === 0) {
          let platform = ["1", "2", "3", "4", "5"];
          if (res.extData.platform) {
            platform = res.extData.platform.split(",");
          }
          this.setState({ goods_info: [res.extData || {}], platform });
          this.getOrderLimits();
          this.getUserAuth();
        } else {
          message.error(res.message);
        }
      });
    }
  }

  //获取用户下单权限
  getOrderLimits = () => {
    API.postUserLimit({}).then((res) => {
      if (res.status * 1 === 0) {
        this.setState({orderStatus: parseInt(res.extData.isBan) || parseInt(res.extData.isBanIp)})
      } else {
        message.error(res.message);
      }
    });
  };

  //获取用户实名信息
  getUserAuth = () => {
    API.getAuthInfo({}).then((res) => {
      if (res.status * 1 === 0) {
        const data = res.extData;
        this.setState({
          isAuth: data.needRealName,
          shopType:data.shopType,
          currentUser:data
        })
        if(parseInt(data.needRealName) === 1) {
          this.setState({
            isShowAuth: true
          })
        }
      }
    })
  };

  getReceiverInfo = () => {
    const {
      receiver_list,
      dataPlatform,
      inputType,
      file_url,
      goodsId,
      orderStatus,
      isAuth,
      addressData,
      goods_info,
      sendName,
      sendMobile
    } = this.state;
    let {receiver_info} = this.state;
    if(orderStatus){
      message.error("平台检测到你多次违规，账号已被限制使用");
      return;
    }
    if(parseInt(isAuth) === 1) {
      this.setState({
        isShowAuth: true
      })
      return;
    }
    if (!goodsId) {
      message.error("请选择商品");
      return;
    }
    if (!dataPlatform) {
      message.error("请选择平台");
      return;
    }
    if (goods_info.length && goods_info[0].sourceYc === 2 && !sendName) {
      message.error("请选择发件人姓名");
      return;
    }
    if (goods_info.length && goods_info[0].sourceYc === 2 && !sendMobile) {
      message.error("请选择发件人手机号");
      return;
    }
    const reqData = { goodsId, dataPlatform, inputType };
    const new_receiver_list = [];
    if (inputType === 1) {
      if (!receiver_info) {
        message.error("请输入收件人信息");
        return;
      }
      let receiver_info_old = receiver_info.split("\n");
      let receiver_label = [];
      let receiver_con = [];
      receiver_info_old.forEach(item => {
        item = item.replace(/：/g, ":");
        if(item.includes(':') && !item.includes(',') && !item.includes('，')){
          receiver_label.push(item.split(':')[0]);
          receiver_con.push(item.split(':')[1]);
        }
      });
      if(receiver_label.length >= 3){
        receiver_info = receiver_con.join(',');
      } else if(receiver_label.length > 0 && receiver_label.length < 3){
        message.warning('请完善收件人信息');
        return ;
      }

      let list = receiver_info.split("\n"),
        i = false;
      list = list.filter((e) => {
        return !!e;
      });
      if (list.length > 0) {
        list = list.map((item) => {
          let a = item
            .replace(/，/g, ",")
            .replace(/\(可不填\)/g, "")
            .replace(
              /[`~!@#$%^&*()+=|{}:;\\.<>/?~！@#￥%…&*（）—+|【】‘；：”“’。、？']/g,
              ""
            )
            .trim()
            .replace(/\s+/g, " ");
          return (a = a
            .split(",")
            .map((val) => {
              return val.trim();
            })
            .join(","));
        });
        const o = {
          addressError: [],
          infoError: [],
          mobileError: [],
          nameError: [],
          keysError: [],
        };
        const checked = !list.every((e, t) => {
          let a = e.split(","),
            r = a.length,
            idx = 2;
          if (parseFloat(a[0].replace(/[^0-9]/gi, "")) >= 100000) {
            idx = 3;
          }
          return r >= 3 && a[idx]
            ? a[idx].split(" ").length >= 3 ||
                (o.addressError.push(t + 1), (i = true), !1)
            : (o.infoError.push(t + 1), !1);

          // if(r >= 3 && a[idx]){
          //   Keys.forEach(item => {
          //     if(a[idx].includes(item)){
          //       o.keysError.push(item);
          //     }
          //   });
          //   if(o.keysError.length){
          //     o.addressError.push(t + 1);
          //     return false;
          //   }
          //   return a[idx].split(" ").length >= 3 ||
          //   (o.addressError.push(t + 1), (i = true), !1);
          // }else{
          //   return (o.infoError.push(t + 1), !1);
          // }
        });
        if (checked) {
          // if(o.keysError.length){
          //   let e = "第" + o.addressError.join() + "行收件人信息中包含违禁词" + o.keysError.join('、') + "， 请修改后按照格式示例标准填写";
          //   message.error(e);
          //   return;
          // }
          let r = i
            ? "第" +
              o.addressError.join() +
              "行收件人信息格式有误,请按照格式示例标准填写,省 市 区 详细地址中间用空格分隔"
            : "第" +
              o.infoError.join() +
              "行收件人信息格式有误，请按照格式示例标准填写！";
          message.error(r);
          return;
        }
        const mobileChecked = !list.every((e, t) => {
          let a = e.split(","),
            idx = 1;
          if (parseFloat(a[0].replace(/[^0-9]/gi, "")) >= 100000) {
            idx = 2;
          }
          const r = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
            a[idx].substr(a[idx].indexOf(1))
          );
          const r1 = /^(1[3456789]\d{9}-\d{4})$/.test(a[idx].substr(a[idx].indexOf(1)));
          return r || r1 ? true : (o.mobileError.push(t + 1), false);
        });
        if (mobileChecked) {
          let r =
            "第" +
            o.mobileError.join() +
            "行收件人电话信息有误,请按照格式示例标准填写";
          message.error(r);
          return;
        }
        const nameChecked = !list.every((e, t) => {
          let a = e.split(","),
            idx = 0;
          if (parseFloat(a[0].replace(/[^0-9]/gi, "")) >= 100000) {
            idx = 1;
          }
          const r = a[idx].length > 1;
          return r ? true : (o.nameError.push(t + 1), false);
        });
        if (nameChecked) {
          let r =
            "第" +
            o.nameError.join() +
            "行收件人姓名信息有误,至少两个字符,请按照格式示例标准填写";
          message.error(r);
          return;
        }
        list.forEach((item, idx) => {
          const i = item.split(",");
          let isOrder = false;
          if (parseFloat(i[0].replace(/[^0-9]/gi, "")) >= 100000) {
            isOrder = true;
          }
          const num = i[isOrder ? 3 : 2].replace(/\s+/g, " ").split(" ");
          const isProvince = num.length > 3;
          if (!isProvince) {
            num.unshift("");
          }
          for (let j in cityArea) {
            cityArea[j].map((item) => {
              if (
                num[1].length >= 2 &&
                item.name.indexOf(num[1]) !== -1 &&
                item.name[0] === num[1][0]
              ) {
                num[0] = item.province;
                num[1] = item.name;
              }
            });
          }
          if (
            isOrder &&
            (receiver_list.find((val) => {
              return val.tradeSn === i[0];
            }) || new_receiver_list.find((val) => {
              return val.tradeSn === i[0];
            }) )
          ) {
            message.success(`第${idx + 1}行定单编号有重复，已过滤`);
          } else {
            const obj = {
              tradeSn: isOrder ? i[0] : "",
              receiveName: isOrder ? i[1] : i[0],
              receiveMobile: i[isOrder ? 2 : 1].substr(
                i[isOrder ? 2 : 1].indexOf(1)
              ),
              receiveProvince: num[0],
              receiveCity: num[1],
              receiveArea: num[2],
              // receiveAddress: num.slice(3).join(" "),
              receiveAddress: i[isOrder ? 3 : 2].replace(/\s+/g, " "),
              shopName: isOrder ? (i.length > 4 ? i[4] : '') : (i.length > 3 ? i[3] : '')
            };
            new_receiver_list.push(obj);
          }
        });
        if (new_receiver_list.length === 0) {
          return;
        }
        reqData.inputData = JSON.stringify(new_receiver_list);
      }
    } else {
      if (!file_url) {
        message.error("请上传文件");
        return;
      }
      reqData.inputData = file_url;
    }

    const immediateData={
      "inputData":reqData.inputData,
      "goodsId":reqData.goodsId,
      "token":reqData.token
    }
    API.postImmediateAddress(immediateData).then((res) => {
      
      if (res && res.extData && Array.isArray(res.extData) && res.extData.length>0 ) {
        this.setState({
          addressData: res.extData
        })
        this.setState({
          isModalOpen: true
        })
      }else{
        this.setState({ loading: true });
        API.postReceiver(reqData).then((res) => {
           this.setState({ loading: false });
           if (res.status * 1 === 0) {
           const list = receiver_list.concat(res.extData || []);
           this.setState({
             receiver_list: list,
             update_list: list,
             receiver_info: "",
            file_url: "",
           });
           document.getElementById("receiverList").scrollIntoView();
          } else {
             message.error(res.message || "解析错误");
          }
       });
      }
    });
  };

  getReceiverTwoInfo = () => {
    this.setState({ isModalOpen: false });
    const {
      receiver_list,
      dataPlatform,
      inputType,
      file_url,
      goodsId,
      orderStatus,
      isAuth,
      addressData
    } = this.state;
    let {receiver_info} = this.state;
    if(orderStatus){
      message.error("平台检测到你多次违规，账号已被限制使用");
      return;
    }
    if(parseInt(isAuth) === 1) {
      this.setState({
        isShowAuth: true
      })
      return;
    }
    if (!goodsId) {
      message.error("请选择商品");
      return;
    }
    if (!dataPlatform) {
      message.error("请选择平台");
      return;
    }
    const reqData = { goodsId, dataPlatform, inputType };
    const new_receiver_list = [];
    if (inputType === 1) {
      if (!receiver_info) {
        message.error("请输入收件人信息");
        return;
      }
      let receiver_info_old = receiver_info.split("\n");
      let receiver_label = [];
      let receiver_con = [];
      receiver_info_old.forEach(item => {
        item = item.replace(/：/g, ":");
        if(item.includes(':') && !item.includes(',') && !item.includes('，')){
          receiver_label.push(item.split(':')[0]);
          receiver_con.push(item.split(':')[1]);
        }
      });
      if(receiver_label.length >= 3){
        receiver_info = receiver_con.join(',');
      } else if(receiver_label.length > 0 && receiver_label.length < 3){
        message.warning('请完善收件人信息');
        return ;
      }

      let list = receiver_info.split("\n"),
        i = false;
      list = list.filter((e) => {
        return !!e;
      });
      if (list.length > 0) {
        list = list.map((item) => {
          let a = item
            .replace(/，/g, ",")
            .replace(/\(可不填\)/g, "")
            .replace(
              /[`~!@#$%^&*()+=|{}:;\\.<>/?~！@#￥%…&*（）—+|【】‘；：”“’。、？']/g,
              ""
            )
            .trim()
            .replace(/\s+/g, " ");
          return (a = a
            .split(",")
            .map((val) => {
              return val.trim();
            })
            .join(","));
        });
        const o = {
          addressError: [],
          infoError: [],
          mobileError: [],
          nameError: [],
          keysError: [],
        };
        const checked = !list.every((e, t) => {
          let a = e.split(","),
            r = a.length,
            idx = 2;
          if (parseFloat(a[0].replace(/[^0-9]/gi, "")) >= 100000) {
            idx = 3;
          }
          return r >= 3 && a[idx]
            ? a[idx].split(" ").length >= 3 ||
                (o.addressError.push(t + 1), (i = true), !1)
            : (o.infoError.push(t + 1), !1);

          // if(r >= 3 && a[idx]){
          //   Keys.forEach(item => {
          //     if(a[idx].includes(item)){
          //       o.keysError.push(item);
          //     }
          //   });
          //   if(o.keysError.length){
          //     o.addressError.push(t + 1);
          //     return false;
          //   }
          //   return a[idx].split(" ").length >= 3 ||
          //   (o.addressError.push(t + 1), (i = true), !1);
          // }else{
          //   return (o.infoError.push(t + 1), !1);
          // }
        });
        if (checked) {
          // if(o.keysError.length){
          //   let e = "第" + o.addressError.join() + "行收件人信息中包含违禁词" + o.keysError.join('、') + "， 请修改后按照格式示例标准填写";
          //   message.error(e);
          //   return;
          // }
          let r = i
            ? "第" +
              o.addressError.join() +
              "行收件人信息格式有误,请按照格式示例标准填写,省 市 区 详细地址中间用空格分隔"
            : "第" +
              o.infoError.join() +
              "行收件人信息格式有误，请按照格式示例标准填写！";
          message.error(r);
          return;
        }
        const mobileChecked = !list.every((e, t) => {
          let a = e.split(","),
            idx = 1;
          if (parseFloat(a[0].replace(/[^0-9]/gi, "")) >= 100000) {
            idx = 2;
          }
          const r = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
            a[idx].substr(a[idx].indexOf(1))
          );
          const r1 = /^(1[3456789]\d{9}-\d{4})$/.test(a[idx].substr(a[idx].indexOf(1)));
          return r || r1 ? true : (o.mobileError.push(t + 1), false);
        });
        if (mobileChecked) {
          let r =
            "第" +
            o.mobileError.join() +
            "行收件人电话信息有误,请按照格式示例标准填写";
          message.error(r);
          return;
        }
        const nameChecked = !list.every((e, t) => {
          let a = e.split(","),
            idx = 0;
          if (parseFloat(a[0].replace(/[^0-9]/gi, "")) >= 100000) {
            idx = 1;
          }
          const r = a[idx].length > 1;
          return r ? true : (o.nameError.push(t + 1), false);
        });
        if (nameChecked) {
          let r =
            "第" +
            o.nameError.join() +
            "行收件人姓名信息有误,至少两个字符,请按照格式示例标准填写";
          message.error(r);
          return;
        }
        list.forEach((item, idx) => {
          const i = item.split(",");
          let isOrder = false;
          if (parseFloat(i[0].replace(/[^0-9]/gi, "")) >= 100000) {
            isOrder = true;
          }
          const num = i[isOrder ? 3 : 2].replace(/\s+/g, " ").split(" ");
          const isProvince = num.length > 3;
          if (!isProvince) {
            num.unshift("");
          }
          for (let j in cityArea) {
            cityArea[j].map((item) => {
              if (
                num[1].length >= 2 &&
                item.name.indexOf(num[1]) !== -1 &&
                item.name[0] === num[1][0]
              ) {
                num[0] = item.province;
                num[1] = item.name;
              }
            });
          }
          if (
            isOrder &&
            (receiver_list.find((val) => {
              return val.tradeSn === i[0];
            }) || new_receiver_list.find((val) => {
              return val.tradeSn === i[0];
            }) )
          ) {
            message.success(`第${idx + 1}行定单编号有重复，已过滤`);
          } else {
            const obj = {
              tradeSn: isOrder ? i[0] : "",
              receiveName: isOrder ? i[1] : i[0],
              receiveMobile: i[isOrder ? 2 : 1].substr(
                i[isOrder ? 2 : 1].indexOf(1)
              ),
              receiveProvince: num[0],
              receiveCity: num[1],
              receiveArea: num[2],
              // receiveAddress: num.slice(3).join(" "),
              receiveAddress: i[isOrder ? 3 : 2].replace(/\s+/g, " "),
              shopName: isOrder ? (i.length > 4 ? i[4] : '') : (i.length > 3 ? i[3] : '')
            };
            new_receiver_list.push(obj);
          }
        });
        if (new_receiver_list.length === 0) {
          return;
        }
        reqData.inputData = JSON.stringify(new_receiver_list);
      }
    } else {
      if (!file_url) {
        message.error("请上传文件");
        return;
      }
      reqData.inputData = file_url;
    }

    const immediateData={
      "inputData":reqData.inputData,
      "goodsId":reqData.goodsId,
      "token":reqData.token
    }

    this.setState({ loading: true });
        API.postReceiver(reqData).then((res) => {
           this.setState({ loading: false });
           if (res.status * 1 === 0) {
           const list = receiver_list.concat(res.extData || []);
           this.setState({
             receiver_list: list,
             update_list: list,
             receiver_info: "",
            file_url: "",
           });
           document.getElementById("receiverList").scrollIntoView();
          } else {
             message.error(res.message || "解析错误");
          }
       });
  };

  //跳转更近的商品下单页面
  gotoGoodsName = (val) => {
    window.open( `https://df.duoduolang.com/#/seller/goods/goodsinfo?${val.id}`);  
  }

  overData = (e) => {
    this.setState({
      overAt: e,
      isShowOver: true
    })
  }

  // 编辑收货人信息
  opeatorReceiver = (idx, type) => {
    const { receiver_list, update_list, goodsId, dataPlatform } = this.state;
    const list = JSON.parse(JSON.stringify(receiver_list));
    if (type === "delete") {
      list.splice(idx, 1);
    }
    if (type === "parseOk") {
      list[idx].parseOk = 1 - receiver_list[idx].parseOk * 1;
    }
    if (type === "cancel") {
      list[idx].parseOk = 1 - receiver_list[idx].parseOk * 1;
      update_list[idx] = list[idx];
    }
    if (type === "update") {
      const reqData = { goodsId, dataPlatform, inputType: 1 };
      const {
        receiveProvince,
        receiveCity,
        receiveArea,
        receiveAddress
      } = update_list[idx];
      update_list[
        idx
      ].receiveAddress = `${receiveProvince} ${receiveCity} ${receiveArea} ${receiveAddress}`;
      reqData.inputData = JSON.stringify([update_list[idx]]);
      API.postReceiver(reqData).then((res) => {
        if (res.status * 1 === 0) {
          list[idx] = res.extData[0];
          if (res.extData[0].parseOk * 1 === 0) {
            message.error(res.extData[0].parseMsg || "解析错误");
          }
          this.setState({ receiver_list: list, update_list: list });
        } else {
          message.error(res.message || "解析错误");
        }
      });
      return;
    }
    this.setState({ receiver_list: list, update_list: list });
  };

  // 更新收货人信息
  updateReceiver = (e, idx, type) => {
    const { update_list } = this.state;
    const list = JSON.parse(JSON.stringify(update_list));
    list[idx][type] = e;
    if (type === "receiveProvince") {
      list[idx].provinceCode = e;
      proArea.map((item) => {
        if (item.id * 1 === e * 1) {
          list[idx][type] = item.name;
        }
      });
    }
    if (type === "receiveCity") {
      list[idx].cityCode = e;
      cityArea[update_list[idx].provinceCode].map((item) => {
        if (item.id * 1 === e * 1) {
          list[idx][type] = item.name;
        }
      });
    }
    if (type === "receiveArea") {
      list[idx].areaCode = e;
      countyArea[update_list[idx].cityCode].map((item) => {
        if (item.id * 1 === e * 1) {
          list[idx][type] = item.name;
        }
      });
    }
    this.setState({ update_list: list });
  };

  // 防抖，防止高频率操作
  debounce = (fn, wait = 600) =>{
    let timeout = null;
    return function() {
      if(timeout !== null) clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    }
  };

  // 下一步
  saveReceiverInfo = () => {
    this.setState({btnDisabled: true});
    const { goodsId, dataPlatform, receiver_list, remark, sendName, sendMobile, goods_info} = this.state;
    if (!goodsId) {
      message.error("请选择商品");
      return;
    }
    if (receiver_list.length === 0) {
      message.error("请填写收货人信息");
      return;
    }
    if (!dataPlatform) {
      message.error("请选择平台");
      return;
    }
    if (goods_info.length && goods_info[0].sourceYc === 2 && !sendName) {
      message.error("请选择发件人姓名");
      return;
    }
    if (goods_info.length && goods_info[0].sourceYc === 2 && !sendMobile) {
      message.error("请选择发件人手机号");
      return;
    }
    for (let item of receiver_list) {
      if (item.parseOk * 1 !== 1) {
        message.error("收件人信息有异常，请检查");
        return;
      }
    }
    
    this.setState({ saveLoading: true });
    const data = {dataPlatform:dataPlatform};
    data.inputData = JSON.stringify(receiver_list);
    if(dataPlatform===2){
      API.postSaveLiReceiver(data).then((res) => {
        this.setState({ saveLoading: false });
        if(res.status === 300){
          this.setState({ isModalLiOpen: true, liMessage:res.message});
        }else{
          const reqData = { goodsId, platform: dataPlatform, goodsNum: 1, from: 1, remark };
          reqData.receiverList = JSON.stringify(receiver_list);
          if(goods_info.length && goods_info[0].sourceYc === 2){
            reqData.sendName=sendName;
            reqData.sendMobile=sendMobile;
          }
          API.postSaveReceiver(reqData).then((res) => {
            if (res.status * 1 === 0) {
              this.props.history.push({
                pathname: `/seller/goods/goodsconfirm?${res.extData.orderId}`,
              });;
              window.location.reload();
            } else if (res.status * 1 === -12431) {
              message.error(res.message || "地址错误");
              this.setState({ receiver_list: res.extData, update_list: res.extData });
            } else {
              message.error(res.message || "保存失败");
            }
            this.setState({btnDisabled: false})
            this.setState({ saveLoading: false });
          });
        }
      });
      return;
    }

    const reqData = { goodsId, platform: dataPlatform, goodsNum: 1, from: 1, remark };
    reqData.receiverList = JSON.stringify(receiver_list);
    if(goods_info.length && goods_info[0].sourceYc === 2){
      reqData.sendName=sendName;
      reqData.sendMobile=sendMobile;
    }
    
    API.postSaveReceiver(reqData).then((res) => {
      if (res.status * 1 === 0) {
        this.props.history.push({
          pathname: `/seller/goods/goodsconfirm?${res.extData.orderId}`,
        });;
        window.location.reload();
      } else if (res.status * 1 === -12431) {
        message.error(res.message || "地址错误");
        this.setState({ receiver_list: res.extData, update_list: res.extData });
      } else {
        message.error(res.message || "保存失败");
      }
      this.setState({btnDisabled: false})
      this.setState({ saveLoading: false });
    });
  };

  handleLiOk = () => {
    this.setState({btnDisabled: true});
    const { goodsId, dataPlatform, receiver_list, remark } = this.state;
    if (!goodsId) {
      message.error("请选择商品");
      return;
    }
    if (receiver_list.length === 0) {
      message.error("请填写收货人信息");
      return;
    }
    if (!dataPlatform) {
      message.error("请选择平台");
      return;
    }
    for (let item of receiver_list) {
      if (item.parseOk * 1 !== 1) {
        message.error("收件人信息有异常，请检查");
        return;
      }
    }
    
    this.setState({ saveLoading: true });
    const reqData = { goodsId, platform: dataPlatform, goodsNum: 1, from: 1, remark };
    reqData.receiverList = JSON.stringify(receiver_list);
    API.postSaveReceiver(reqData).then((res) => {
      if (res.status * 1 === 0) {
        this.props.history.push({
          pathname: `/seller/goods/goodsconfirm?${res.extData.orderId}`,
        });;
        window.location.reload();
      } else if (res.status * 1 === -12431) {
        message.error(res.message || "地址错误");
        this.setState({ receiver_list: res.extData, update_list: res.extData });
      } else {
        message.error(res.message || "保存失败");
      }
      this.setState({btnDisabled: false})
      this.setState({ saveLoading: false });
    });
  }

  // 上传文件
  handleChange = (info) => {
    if (info.file.status === "uploading") {
      this.setState({ up_loading: true });
      return;
    }
    this.setState({
      up_loading: false,
    });
    if (info.file.status === "error") {
      message.error("文件上传失败！");
      return;
    }
    if (info.file.status === "done") {
      let res = info.file.response;
      if (res.status * 1 === 0) {
        this.setState({ file_url: res.extData.fileUrl });
      } else {
        message.error(res.message || "文件上传失败！");
      }
    }
  };

  onOpenHref = () => {
    const { dataPlatform } = this.state;
    if(dataPlatform === 1) {
      window.open("https://cdn.abc11223.com/source/daifa/video/plugin_video.mp4")
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'goodsinfo', 'video', 'taobao'])
      }
    } else {
      window.open("https://cdn.abc11223.com/source/daifa/video/pdd_daifa.mp4")
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'goodsinfo', 'video', 'pdd'])
      }
    }
  };

  toAuth = () => {
    window.open(`/#/seller/account/home?status=1`,'_self')
  };

  radioChange = (e) =>{
    const { shopType,goods_info,currentUser } = this.state;
    this.setState({ dataPlatform: e.target.value, inputType: 1})
    
    // if(((e.target.value === 3 && shopType === 2)|| 
    //     (e.target.value === 1&&currentUser.shopTypeTb === 2)||
    //     (e.target.value === 5&&currentUser.shopTypeDy === 2)|| 
    //     (e.target.value === 2&&currentUser.shopTypeJd === 2))
    //   && Array.isArray(goods_info) 
    //   && ((goods_info[0].sourceYc===1) || (goods_info[0].sourceYc===0)) ){
    //   this.setState({ isBtn1Disabled: false})
    // }else if((e.target.value === 1&&currentUser.shopTypeTb === 2)&& Array.isArray(goods_info)&& goods_info[0].sourceYc===0){
    //   this.setState({ isBtn1Disabled: false})
    // }else{
    //   this.setState({ isBtn1Disabled: true})
    // }


    //淘宝自动下单条件(选择的淘宝平台&&绑定了淘宝店铺&&支持一号仓和二号仓)
    if(e.target.value === 1
      &&currentUser.shopTypeTb === 2
      &&Array.isArray(goods_info)
      &&((goods_info[0].sourceYc===1) || (goods_info[0].sourceYc===0))){
        this.setState({ isBtn1Disabled: false})
    }else if(e.target.value === 2
      &&currentUser.shopTypeJd === 2
      &&Array.isArray(goods_info)
      &&goods_info[0].sourceYc===1){
      // 京东自动下单条件(选择的京东平台&&绑定了淘宝店铺&&支持二号仓)
      this.setState({ isBtn1Disabled: false})
    }else if(e.target.value === 3
      &&currentUser.shopType === 2
      &&Array.isArray(goods_info)
      &&goods_info[0].sourceYc===1){
      // pdd自动下单条件(选择的pdd平台&&绑定了淘宝店铺&&支持二号仓)
      this.setState({ isBtn1Disabled: false})
    }else if(e.target.value === 5
      &&currentUser.shopTypeDy === 2
      &&Array.isArray(goods_info)
      &&goods_info[0].sourceYc===1){
      // dy自动下单条件(选择的dy平台&&绑定了淘宝店铺&&支持二号仓)
      this.setState({ isBtn1Disabled: false})
    }else{
      this.setState({ isBtn1Disabled: true})
    }
    if(e.target.value===5){
      Modal.info({
        title: "提示",
        content: "因抖音平台新规，抖音订单编号必填",
        okText: "确认",
        onOk: this.checkDyId
      });
    }
  }

  checkDyId = () => {
    API.getCheckDyId({}).then((res) => {
      if (res.status * 1 === 0) {
        if (!res.extData) {
          this.setState({ isDyIdModalOpen: true });
        }
      } else {
        message.error(res.message || "检查失败");
      }
    });
  };

  handleDyIdSubmit = () => {
    const { dyShopId } = this.state;
    if (!dyShopId) {
      message.error("请输入店铺ID");
      return;
    }
    API.postAddDyShopId({ shopId: dyShopId }).then((res) => {
      if (res.status * 1 === 0) {
        this.setState({ isDyIdModalOpen: false });
        message.success("提交成功");
      } else {
        message.error(res.message || "提交失败");
      }
    });
  };


  //调接口获取导入列表数据
  handleRadioBtnClick = () =>{
    const { dataPlatform,isBtn1Disabled } = this.state;
    if(isBtn1Disabled || !dataPlatform){
      return;
    }
    this.setState({ pddLoading:true})
    if(dataPlatform === 1){
      API.getTbList({}).then((res) => {
        if (res.extData.code * 1 === 200) {
          this.setState({ data: res.extData.data})
          this.setState({ pddLoading:false})
        } else {
          this.setState({ pddLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    } else if(dataPlatform===3){
      API.getPddList({}).then((res) => {
        if (res.extData.code * 1 === 200) {
          this.setState({ data: res.extData.data})
          this.setState({ pddLoading:false})
        } else {
          this.setState({ pddLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    }else if(dataPlatform===5){
      API.getDyList({}).then((res) => {
        if (res.extData.code * 1 === 200) {
          this.setState({ data: res.extData.data})
          this.setState({ pddLoading:false})
        } else {
          this.setState({ pddLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    }else if(dataPlatform===2){
      API.getJdList({}).then((res) => {
        if (res.extData.code * 1 === 200) {
          this.setState({ data: res.extData.data})
          this.setState({ pddLoading:false})
        } else {
          this.setState({ pddLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    }
  }

  // 跳转自动下单流程
  goToAutoList = () => {
    this.props.history.push({
      pathname: '/seller/order/autolist',
    });
    // window.location.reload();
  }

    // 处理表格勾选变化
    handleSelectChange = (selectedRowKeys) => {
      this.setState({ selectedOrderSn: selectedRowKeys });
    };

    //pdd/tb/dy/jd订单预览
    savePddReceiverInfo = () => {
      this.setState({btnDisabled: true});
      const { goodsId, dataPlatform, selectedOrderSn,goods_info, sendName, sendMobile} = this.state;
      if (!goodsId) {
        message.error("请选择商品");
        return;
      }
      if (!dataPlatform) {
        message.error("请选择平台");
        return;
      }
      if (selectedOrderSn.length === 0) {
        message.error("请勾选所需下单订单");
        return;
      }
      if (goods_info.length && goods_info[0].sourceYc === 2 && !sendName) {
        message.error("请选择发件人姓名");
        return;
      }
      if (goods_info.length && goods_info[0].sourceYc === 2 && !sendMobile) {
        message.error("请选择发件人手机号");
        return;
      }

      this.setState({ saveLoading: true });
      const reqData = { goodsId, orderSns: selectedOrderSn };
      if(goods_info.length && goods_info[0].sourceYc === 2){
        reqData.sendName=sendName;
        reqData.sendMobile=sendMobile;
      }
      
      if(dataPlatform===1){
        API.postTbSaveReceiver(reqData).then((res) => {
        
          if (res.extData.code * 1 === 200 || res.extData.code * 1 === 300 ) {
            if(res.extData.code * 1 === 300){
              message.warning(res.extData.message || "部分保存失败");
            }
            this.props.history.push({
              pathname: `/seller/goods/goodsconfirm?${res.extData.orderId}`,
            });
            window.location.reload();
          } else {
            message.error(res.extData.message || "保存失败");
          }
          this.setState({btnDisabled: false})
          this.setState({ saveLoading: false });
        });
      }else if(dataPlatform===3){
        API.postPddSaveReceiver(reqData).then((res) => {
        
          if (res.extData.code * 1 === 200 || res.extData.code * 1 === 300 ) {
            if(res.extData.code * 1 === 300){
              message.warning(res.extData.message || "部分保存失败");
            }
            this.props.history.push({
              pathname: `/seller/goods/goodsconfirm?${res.extData.orderId}`,
            });
            window.location.reload();
          } else {
            message.error(res.extData.message || "保存失败");
          }
          this.setState({btnDisabled: false})
          this.setState({ saveLoading: false });
        });
      }else if(dataPlatform===5){
        API.postDySaveReceiver(reqData).then((res) => {
        
          if (res.extData.code * 1 === 200 || res.extData.code * 1 === 300 ) {
            if(res.extData.code * 1 === 300){
              message.warning(res.extData.message || "部分保存失败");
            }
            this.props.history.push({
              pathname: `/seller/goods/goodsconfirm?${res.extData.orderId}`,
            });
            window.location.reload();
          } else {
            message.error(res.extData.message || "保存失败");
          }
          this.setState({btnDisabled: false})
          this.setState({ saveLoading: false });
        });
      }else if(dataPlatform===2){
        API.postJdSaveReceiver(reqData).then((res) => {
        
          if (res.extData.code * 1 === 200 || res.extData.code * 1 === 300 ) {
            if(res.extData.code * 1 === 300){
              message.warning(res.extData.message || "部分保存失败");
            }
            this.props.history.push({
              pathname: `/seller/goods/goodsconfirm?${res.extData.orderId}`,
            });
            window.location.reload();
          } else {
            message.error(res.extData.message || "保存失败");
          }
          this.setState({btnDisabled: false})
          this.setState({ saveLoading: false });
        });
      }
      
    };

    onPddChange = (e) => {
      this.setState({ pddValue: e.target.value });
      this.setState({ pddLoading:true})
      let flg = -1
      if(e.target.value !== 6){
        flg = e.target.value
      }
      API.getPddList({flg:flg}).then((res) => {
        if (res.extData.code * 1 === 200) {
          this.setState({ data: res.extData.data})
          this.setState({ pddLoading:false})
        } else {
          this.setState({ pddLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    }

    onTbChange= (e) => {
      this.setState({ tbValue: e.target.value });
      this.setState({ pddLoading:true})
      let flg = ''
      if(e.target.value !== '6'){
        flg = e.target.value
      }
      API.getTbList({flg:flg}).then((res) => {
        if (res.extData.code * 1 === 200) {
          this.setState({ data: res.extData.data})
          this.setState({ pddLoading:false})
        } else {
          this.setState({ pddLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    }

    onDyChange = (e) => {
      this.setState({ dyValue: e.target.value });
      this.setState({ pddLoading:true})
      let flg = -1
      if(e.target.value !== 6){
        flg = e.target.value
      }
      API.getDyList({flg:flg}).then((res) => {
        if (res.extData.code * 1 === 200) {
          this.setState({ data: res.extData.data})
          this.setState({ pddLoading:false})
        } else {
          this.setState({ pddLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    }

    handleSearchChange = (e) => {
      this.setState({ isOverValue: e.target.value });
      
    }

    onSearchOver = (value) => {
      const {goods_info,isOverValue}=this.state;
      this.setState({ overLoading:true})
      API.postSearchOver({goodsId :goods_info[0].goodsId,area:value}).then((res) => {
        
        if (res.status* 1 === 0) {
          this.setState({ overAt: res.extData.msg})
          this.setState({ overLoading:false})
        } else {
          this.setState({ overLoading:false})
          message.error(res.extData.message || "获取失败");
        }
      });
    }

    overBtnClick = () => {
      this.setState({ isShowOver: false ,isOverValue: null });
      
    }

  render() {
    const {
      goods_info,
      inputType,
      dataPlatform,
      isBtn1Disabled,
      receiver_info,
      sendName, //发件人姓名
      sendMobile, //发件人手机号
      receiver_list,
      update_list,
      up_loading,
      file_url,
      platform,
      loading,
      saveLoading,
      isShowAuth,
      isShowOver,
      isModalOpen,
      addressData,
      selectedOrderSn,
      data,
      pddLoading,
      isModalLiOpen,
      liMessage,
      pddValue,
      tbValue,
      dyValue,
      overAt,
      isOverValue,
      overLoading,
      isDyIdModalOpen,
      dyShopId
    } = this.state;

    const columns = [
      {
        title: "商品名称",
        dataIndex: "goodsName",
        width: "23%",
        render: (e, record) => {
          return (
            <div className="flex-start">
              <img
                src={record.goodsImg}
                alt=""
                style={{ width: 50, height: 50, marginRight: 10 }}
              />
              {e}
            </div>
          );
        },
      },
      {
        title: "单价",
        dataIndex: "goodsFee",
        width: "8%",
        render: (e) => {
          return <div>
            {(e / 100).toFixed(2)}
          </div>;
        },
      },
      {
        title: "使用说明",
        dataIndex: "instructions",
        width: "19%",
        render: (e) => {
          return <div style={{color:'red'}}>
            {e}
          </div>;
        },
      },
      {
        title: "禁发地址",
        dataIndex: "stopArea",
        width: "6%",
        render: (e) => {
          return <div style={{color:'red'}}>
            <Button type="primary" style={{marginLeft:'10px'}} onClick={()=>this.overData(e)}>查看</Button>
          </div>;
        },
      },
      {
        title: "自动下单",
        dataIndex: "autoPay",
        width: "9%",
        render: (e) => {
          return <div>
            {e===1?"支持":"不支持"}
          </div>;
        },
      },
      {
        title: "采购数量",
        dataIndex: "num",
        width: "9%",
        render: (_) => {
          return <div>1</div>;
        },
      },
      {
        title: "单重量",
        dataIndex: "weight",
        width: "8%",
        render: (e) => {
          return <div>{e}g</div>;
        },
      },
      {
        title: "快递",
        dataIndex: "courier",
        width: "9%",
      },
      {
        title: "发货地",
        dataIndex: "address",
        width: "12%",
        render: (e,record) => {
          return <Tooltip 
          title={
            <div>
              <span style={{margin: "0 15px"}}>{record.warehouseAddress}</span>
              <CopyToClipboard
                text={`${record.warehouseAddress}`}
                onCopy={() => message.success("成功复制发货详细地址")}>
                <Button>复制</Button>
              </CopyToClipboard>
            </div>
          }
          placement="top"
          overlayStyle={{ maxWidth: 'none' }}
        >
          <div>
            {e}...
          </div>
        </Tooltip>;
        },
      },
    ];

    const user_columns = [
      {
        title: "序号",
        dataIndex: "id",
        align: "center",
        render: (e, k, idx) => {
          return <div>{idx + 1 < 10 ? `0${idx + 1}` : idx + 1}</div>;
        },
      },
      {
        title: "订单编号",
        align: "center",
        dataIndex: "tradeSn",
        render: (e, item, idx) => {
          return (
            <div>
              {item.parseOk * 1 === 0 ? (
                <Input
                  defaultValue={e}
                  onChange={(val) =>
                    this.updateReceiver(val.target.value, idx, "tradeSn")
                  }
                />
              ) : (
                <div>{e}</div>
              )}
            </div>
          );
        },
      },
      {
        title: "姓名",
        align: "center",
        dataIndex: "receiveName",
        render: (e, item, idx) => {
          return (
            <div>
              {item.parseOk * 1 === 0 ? (
                <Input
                  defaultValue={e}
                  onChange={(val) =>
                    this.updateReceiver(val.target.value, idx, "receiveName")
                  }
                />
              ) : (
                <div>{e}</div>
              )}
            </div>
          );
        },
      },
      {
        title: "电话",
        align: "center",
        dataIndex: "receiveMobile",
        render: (e, item, idx) => {
          return (
            <div>
              {item.parseOk * 1 === 0 ? (
                <Input
                  defaultValue={e}
                  onChange={(val) =>
                    this.updateReceiver(val.target.value, idx, "receiveMobile")
                  }
                />
              ) : (
                <div>{e}</div>
              )}
            </div>
          );
        },
      },
      {
        title: "地址",
        align: "center",
        dataIndex: "receiveProvince",
        render: (e, item, idx) => {
          return (
            <div>
              {item.parseOk * 1 === 0 && (
                <div>
                  {receiver_list[idx].receiveProvince}&nbsp;
                  {receiver_list[idx].receiveCity}&nbsp;
                  {receiver_list[idx].receiveArea}&nbsp;
                  {receiver_list[idx].receiveAddress}
                  <div style={{ color: "#33AAFF", fontWeight: 600 }}>
                    {item.parseMsg && `解析失败,${item.parseMsg}`}
                  </div>
                </div>
              )}
              <div>
                <div className="flex-start" style={{ marginBottom: 5 }}>
                  {item.parseOk * 1 === 0 ? (
                    <Select
                      placeholder="省"
                      style={{ minWidth: 100 }}
                      onChange={(value) =>
                        this.updateReceiver(value, idx, "receiveProvince")
                      }
                    >
                      {proArea.map((data) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    <div>{e}</div>
                  )}
                  &nbsp;
                  {item.parseOk * 1 === 0 ? (
                    <Select
                      placeholder="市"
                      style={{ minWidth: 100 }}
                      onChange={(value) =>
                        this.updateReceiver(value, idx, "receiveCity")
                      }
                    >
                      {item.provinceCode &&
                      cityArea[item.provinceCode].map((data) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    <div>{item.receiveCity}</div>
                  )}
                </div>
                <div className="flex-start">
                  {item.parseOk * 1 === 0 ? (
                    <Select
                      placeholder="区"
                      style={{ minWidth: 100 }}
                      onChange={(value) =>
                        this.updateReceiver(value, idx, "receiveArea")
                      }
                    >
                      {item.cityCode &&
                      countyArea[item.cityCode || 0] &&
                      countyArea[item.cityCode || 0].map((data) => (
                        <Option key={data.id} value={item.id}>
                          {data.name}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    <div>{item.receiveArea}</div>
                  )}
                  &nbsp;
                  {item.parseOk * 1 === 0 ? (
                    <Input
                      placeholder="请输入详细地址"
                      style={{ minWidth: 120 }}
                      onChange={(val) =>
                        this.updateReceiver(
                          val.target.value,
                          idx,
                          "receiveAddress"
                        )
                      }
                    />
                  ) : (
                    <div>{item.receiveAddress}</div>
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        title: "店铺名称",
        align: "center",
        dataIndex: "shopName",
        render: (e, item, idx) => {
          return (
            <div>
              {item.parseOk * 1 === 0 ? (
                <Input
                  defaultValue={e}
                  onChange={(val) =>
                    this.updateReceiver(val.target.value, idx, "shopName")
                  }
                />
              ) : (
                <div>{e}</div>
              )}
            </div>
          );
        },
      },
      {
        title: "操作",
        align: "center",
        dataIndex: "parseOk",
        width: 170,
        render: (e, k, idx) => {
          return (
            <div>
              {e * 1 === 0 ? (
                <Fragment>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={(_) => this.opeatorReceiver(idx, "cancel")}
                  >
                    取消
                  </span>
                  <span
                    style={{ cursor: "pointer", marginLeft: 10 }}
                    onClick={(_) => this.opeatorReceiver(idx, "update")}
                  >
                    确认修改
                  </span>
                </Fragment>
              ) : (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(_) => this.opeatorReceiver(idx, "parseOk")}
                >
                  编辑
                </span>
              )}
              <span
                style={{ color: "#33AAFF", marginLeft: 10, cursor: "pointer" }}
                onClick={(_) => this.opeatorReceiver(idx, "delete")}
              >
                删除
              </span>
            </div>
          );
        },
      },
    ];

    const columnsData = [
      {
        title: "商品名称",
        dataIndex: "goodsName",
        width: "23%",
        render: (e, record) => {
          return (
            <div 
              className="flex-start"
              style={{cursor: 'pointer'}}
              onClick={() =>
              this.gotoGoodsName(record)
            }>
              <img
                src={record.goodsImg}
                alt=""
                style={{ width: 50, height: 50, marginRight: 10 }}
              />
              {e}
            </div>
          );
        },
      },
      {
        title: "快递",
        dataIndex: "courier",
        width: "8%",
      },
      {
        title: "地址",
        dataIndex: "address",
        width: "9%",
      },
    ];

    const columnsPdd = [
      {
        title: '订单号',
        dataIndex: 'orderSn',
      },
      {
        title: '商品名',
        dataIndex: 'goodsName',
      },
      {
        title: '商品图片',
        dataIndex: 'goodsImg',
        render: (text) => <img src={text} alt="商品" style={{ width: 50 }} />,
      },
      {
        title: '商品价格',
        dataIndex: 'goodsPrice',
      },
      {
        title: '商品数量',
        dataIndex: 'goodsCount',
      },
      {
        title: '收货人姓名',
        dataIndex: 'receiverNameMask',
      },
      {
        title: '收货人手机号',
        dataIndex: 'receiverPhoneMask',
      },
      {
        title: '收货人地址',
        dataIndex: 'addressMask',
      },
    ];

    return (
      <div>
        <Steps current={0} style={{ width: "40%", margin: "20px auto" }}>
          <Step title="填写信息 " />
          <Step title="确认订单" />
        </Steps>
        <div style={{ marginBottom: 30 }}>
          <div className="goods_info_title">第一步：选择礼品</div>
          <Table
            columns={columns}
            dataSource={goods_info}
            bordered
            rowKey="goodsId"
            pagination={false}
          />
          {goods_info.length && goods_info[0].remark && (
          <div className="remark" style={{marginTop: 10}}>
            仓库备注：
            <span  style={{color: "rgb(51, 170, 255)"}}>{goods_info[0].remark}</span>
          </div>
          )}
        </div>
        <div style={{ marginBottom: 30 }}>
          <div className="goods_info_title">第二步：选择数据来源平台</div>
          <div className="goods_info_platform">
            <Radio.Group
              value={dataPlatform}
              buttonStyle="solid"
              size="large"
              onChange={(e) => this.radioChange(e) }
            >
              <Radio.Button value={1} disabled={platform.indexOf("1") === -1}>
                淘宝/天猫
              </Radio.Button>
              <Radio.Button value={2} disabled={platform.indexOf("2") === -1}>
                京东
              </Radio.Button>
              <Radio.Button value={3} disabled={platform.indexOf("3") === -1}>
                拼多多
              </Radio.Button>
              <Radio.Button value={5} disabled={platform.indexOf("5") === -1}>
                抖音
              </Radio.Button>
              <Radio.Button value={4} disabled={platform.indexOf("4") === -1}>
                其他
              </Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <div style={{ marginBottom: 20 }}>
          <div className="goods_info_title">第三步：录入收件人信息</div>
          <div className="goods_info_platform">
            <Radio.Group
              value={inputType}
              buttonStyle="solid"
              size="large"
              onChange={(e) => this.setState({ inputType: e.target.value })}
            >
              <Radio.Button value={1}>手动输入</Radio.Button>
              <Radio.Button value={2}>模板导入</Radio.Button>
              <Tooltip 
                title={
                  <div>
                    <p>该商品不支持该数据来源平台自动下单，请前往首页筛选符合条件自动下单商品</p>
                    <p>1.筛选相关平台</p>
                    <p>2.再筛选下单模式(自动下单)</p>
                  </div>
                }
                placement="top" 
                overlayStyle={{ maxWidth: 300 }} 
                visible={isBtn1Disabled ? undefined : false}
              >
                <Radio.Button 
                  value={4} 
                  disabled={isBtn1Disabled} 
                  onClick={this.handleRadioBtnClick}
                >
                  自动下单
                </Radio.Button>
                {/* <Radio.Button 
                  value={4} 
                  disabled={true} 
                  onClick={this.handleRadioBtnClick}
                >
                  自动下单
                </Radio.Button> */}
              </Tooltip>
              {/* <Radio.Button value={4} onClick={this.handleRadioBtnClick}>自动下单</Radio.Button> */}
              {/* <Radio.Button value={4} disabled={isBtn1Disabled} onClick={this.handleRadioBtnClick}>自动下单</Radio.Button> */}
              {/*{(dataPlatform === 1 || dataPlatform === 3) && (*/}
                {/*<Radio.Button value={3}>插件导入</Radio.Button>*/}
              {/*)}*/}
            </Radio.Group>
            {/* {
              (goods_info.length && goods_info[0].sourceYc === 1) && <div style={{color: 'red',marginTop:'20px'}}>
              <label style={{color: '#000'}}>发货提示：</label>
              该商品成功出单后无法退款，请认真核查收件信息是否正确
              </div>
            } */}
            {
              inputType === 4 && (dataPlatform===4 ) && <div style={{color: 'red',marginTop:'20px'}}>
                <label style={{color: '#000'}}>提示：</label>
                <span>如要自动下单，需授权绑定相关下单平台</span>
                <Button type="primary" style={{marginLeft:'10px'}} onClick={this.goToAutoList}>自动下单流程</Button>
              </div>
            }
            {
              inputType === 4 && (dataPlatform=== 3 || dataPlatform===5) && <div style={{color: 'red',marginTop:'20px'}}>
                <label style={{color: '#000'}}>提示：</label>
                <span>如要自动下单，需授权绑定相关下单平台（注意：因电商平台限制，该功能只能获取到最近 1 天内的订单）</span>
                <Button type="primary" style={{marginLeft:'10px'}} onClick={this.goToAutoList}>自动下单流程</Button>
              </div>
            }
                        {
              inputType === 4 && (dataPlatform=== 1 || dataPlatform===2) && <div style={{color: 'red',marginTop:'20px'}}>
                <label style={{color: '#000'}}>提示：</label>
                <span>如要自动下单，需授权绑定相关下单平台（注意：因电商平台限制，该功能只能获取到最近 7 天内的订单）</span>
                <Button type="primary" style={{marginLeft:'10px'}} onClick={this.goToAutoList}>自动下单流程</Button>
              </div>
            }
            <div style={{color: 'red',marginTop:'10px'}}>
              <label style={{color: '#000'}}>发货提示：</label>
              该商品成功出单后无法退款，请认真核查收件信息是否正确
            </div>
          </div>
          {
            inputType !== 4 && <div style={{color: '#33aaff',marginTop:'10px'}}>
            <label style={{color: '#000'}}>发货提示：</label>
            请务必录入真实具体收货信息，虚假地址、地址不详、收件人电话虚假等问题物流将被退回，因此造成损失将由您个人承担
          </div>
          }
        <div>
           {
              (goods_info.length && goods_info[0].sourceYc === 2) && <div style={{marginTop:'10px',}}>
                <Space direction="horizontal">
                 <span>发件人姓名(必填)：</span>
                 <Input 
                   value={sendName} 
                   placeholder="请输入发件人姓名"
                   onChange={(e) =>
                     this.setState({ sendName: e.target.value })
                   } 
                 />
                <span style={{marginLeft:'10px',display:"inline-block"}}>发件人手机号(必填)：</span>
                <Input 
                  value={sendMobile} 
                  placeholder="请输入发件人手机号"
                  onChange={(e) =>
                    this.setState({ sendMobile: e.target.value })
                  } 
               />
               </Space>
              </div>
            }
        </div>
        </div>
        {inputType === 1 ? (
          <Fragment>
            <div>
              <div className="goods_info_tips">
                <div style={{ fontWeight: 600 }}>格式要求：</div>
                <div style={{ color: "#33AAFF" }}>
                  订单编号（可不填）,姓名,电话,地址
                  按顺序填写,中间用逗号分隔，省 市 区 详细地址中间用空格分隔。
                </div>
                <div>一次可以输入多个收件人信息，一个收件人信息一行输入，店铺名称可不填</div>
                <div>示例</div>
                <div style={{ color: "#33AAFF" }}>
                  600000000000，小明，13000000000，浙江省 杭州市 上城区
                  中河北路10号，xx旗舰店
                </div>
                <div>
                  订单编号：淘、猫、京、拼等平台订单编号，<span style={{color: "red"}}>有订单编号能快速出单，方便批量导出匹配发货。如无订单编号可不填写（抖音除外，抖音必填）。</span>
                </div>
                <div>
                  如遇东莞市、中山市、天门市、三沙市、儋州市、嘉峪关市等没有区的城市，区域可设置为“其他区”。
                </div>
              </div>
            </div>
            <div style={{ fontWeight: 600, margin: "20px 0" }}>
              手动输入信息
            </div>
            <TextArea
              value={receiver_info}
              onChange={(e) => this.setState({ receiver_info: e.target.value })}
              placeholder="订单编号（抖音必填），姓名，电话，地址，店铺名称
例如：6000000000，小明，13000000000，浙江省 杭州市 下城区 中河北路10号，xx旗舰店"
              autoSize={{ minRows: 5 }}
            />
          </Fragment>
        ) : inputType === 2 ? (
          <div className="goods_file flex-space">
            <Dragger
              name="file"
              showUploadList={false}
              beforeUpload={beforeUpload}
              action={`${ROOT}/upload/filecos`}
              onChange={this.handleChange}
            >
              {up_loading ? (
                <Spin indicator={antIcon} />
              ) : (
                <Fragment>
                  {file_url ? (
                    <div>
                      <div>
                        <IconFont
                          type="icon-chenggong"
                          style={{
                            fontSize: 54,
                            marginBottom: 10,
                          }}
                        />
                      </div>
                      <div style={{ fontSize: 14 }}>
                        文件上传成功，可
                        <span style={{ color: "#33AAFF" }}>重新上传</span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div>
                        <IconFont
                          type="icon-shangchuanwenjian"
                          style={{
                            fontSize: 46,
                            color: "#333333",
                            marginBottom: 10,
                          }}
                        />
                      </div>
                      <div style={{ fontSize: 14 }}>
                        将文件拖到此处，或
                        <span style={{ color: "#33AAFF" }}>点击上传</span>
                      </div>
                    </div>
                  )}
                </Fragment>
              )}
            </Dragger>
            <div className="goods_file_tips">
              <div style={{ fontWeight: 600 }}>注意事项:</div>
              <div> 1、仅支持CSV、XLSX、XLS文件</div>
              <div>2、文件大小限制在5M以内</div>
              <div
                style={{ color: "#33AAFF", cursor: "pointer" }}
                onClick={(_) =>
                  // `${imgRoot}/help.zip`
                  (window.location.href = "https://static.duoduolang.com/template/order/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx")
                }
              >
                3、导入模板下载
              </div>
            </div>
          </div>
        ) : inputType === 4 && dataPlatform === 1 ? (
          <div>
            <Radio.Group style={{marginBottom:'20px'}} 
              onChange={this.onTbChange} 
              value={tbValue}
            >
              <Radio value={'6'}>全部</Radio>
              <Radio value={'红色旗子'}>红色</Radio>
              <Radio value={'黄色旗子'}>黄色</Radio>
              <Radio value={'绿色旗子'}>绿色</Radio>
              <Radio value={'蓝色旗子'}>蓝色</Radio>
              <Radio value={'紫色旗子'}>紫色</Radio>
            </Radio.Group>
            <Table
              rowSelection={{
                type: 'checkbox',
                onChange: this.handleSelectChange,
              }}
              loading={pddLoading}
              columns={columnsPdd}
              dataSource={data}
              rowKey="orderSn"
              pagination={false}
            />
          </div>
        ): inputType === 4 && dataPlatform ===3 ? (
          <div>
            <Radio.Group style={{marginBottom:'20px'}} 
              onChange={this.onPddChange} 
              value={pddValue}
            >
              <Radio value={6}>全部</Radio>
              <Radio value={1}>红色</Radio>
              <Radio value={2}>黄色</Radio>
              <Radio value={3}>绿色</Radio>
              <Radio value={4}>蓝色</Radio>
              <Radio value={5}>紫色</Radio>
            </Radio.Group>
            <Table
              rowSelection={{
                type: 'checkbox',
                onChange: this.handleSelectChange,
              }}
              loading={pddLoading}
              columns={columnsPdd}
              dataSource={data}
              rowKey="orderSn"
              pagination={false}
            />
          </div>
        ) : inputType === 4 && dataPlatform === 5 ? (
          <div>
            <Radio.Group style={{marginBottom:'20px'}} 
              onChange={this.onDyChange} 
              value={dyValue}
            >
              <Radio value={6}>全部</Radio>
              <Radio value={0}>灰色</Radio>
              <Radio value={1}>紫色</Radio>
              <Radio value={2}>青色</Radio>
              <Radio value={3}>绿色</Radio>
              <Radio value={4}>橙色</Radio>
              <Radio value={5}>红色</Radio>
            </Radio.Group>
            <Table
              rowSelection={{
                type: 'checkbox',
                onChange: this.handleSelectChange,
              }}
              loading={pddLoading}
              columns={columnsPdd}
              dataSource={data}
              rowKey="orderSn"
              pagination={false}
            />
          </div>
        ): inputType === 4 && dataPlatform ===2 ? (
          <div>
            <div style={{color: '#33aaff',marginBottom:'20px'}}>
              <label style={{color: '#000'}}>发货提示：</label>
              京东平台不支持“申通”和“极兔”快递包裹的自动下单，无法自动传递物流单号
            </div>
            <Table
            rowSelection={{
              type: 'checkbox',
              onChange: this.handleSelectChange,
            }}
            loading={pddLoading}
            columns={columnsPdd}
            dataSource={data}
            rowKey="orderSn"
            pagination={false}
          />
         </div>
        ) : inputType === 4 ? (
          <div>
            <Table
            rowSelection={{
              type: 'checkbox',
              onChange: this.handleSelectChange,
            }}
            loading={pddLoading}
            columns={columnsPdd}
            dataSource={data}
            rowKey="orderSn"
            pagination={false}
          />
         </div>
        ) : (
          <div className="goods_file flex-space">
            <div className="goods_file_plugin">
              <img
                src="https://cdn.abc11223.com/source/daifa/ddd-headicon.png"
                alt=""
              />
              <Button
                type="primary"
                size="large"
                onClick={(_) => window.open("https://abc11223.com/help.html")}
              >
                下载插件
              </Button>
            </div>
            <div className="goods_file_tips">
              <div style={{ fontWeight: 600 }}>注意事项:</div>
              <div>
                1、支持平台：
                {dataPlatform === 1 ? "淘宝、天猫" : "拼多多"}
              </div>
              <div>
                2、插件安装教程：点击
                <span
                  style={{ color: "#33AAFF", cursor: "pointer" }}
                  onClick={(_) =>
                    window.open("https://abc11223.com/help.html")
                  }
                >
                  【下载插件】
                </span>
                ，跳转页面有详细的下载地址以及安装教程
              </div>
              <div>
                3、使用教程：
                <span
                  style={{ color: "#33AAFF", cursor: "pointer" }}
                  onClick={(_) => this.onOpenHref()}
                >
                  操作步骤
                </span>
              </div>
            </div>
          </div>
        )}
        {inputType !== 3 && inputType !== 4 && (
          <Fragment>
            <div style={{margin: "20px auto", textAlign: "center"}}>
              <Button
                type="primary"
                size="large"
                onClick={this.getReceiverInfo}
                loading={loading}
              >
                生成收件人信息
              </Button>
            </div>
            {receiver_list.length > 0 ? (
              <div id="receiverList">
                <div style={{margin: "20px 0"}}>
                  <span style={{fontWeight: 600}}>收件人信息</span>
                  <span style={{float: 'right'}}><InfoCircleOutlined style={{marginRight: 3}}/>
                    地址为机器识别，可能会出现错误，请您核查后下单
                    <Button
                      type="primary"
                      size="small"
                      style={{marginLeft: 10}}
                      onClick={() => this.setState({receiver_list: [], update_list: []})}>
                      清空收件人信息
                    </Button>
                  </span>
                </div>
                <Table
                  columns={user_columns}
                  dataSource={update_list}
                  bordered
                  rowKey="tradeSn"
                  pagination={false}
                />
              </div>
            ) : null}
            {receiver_list.length > 0 ? (
              <div>
                <div style={{fontWeight: 600, margin: "20px 0"}}>
                  备注信息（非必填）
                </div>
                <TextArea
                  placeholder="备注信息仅在平台浏览，可不填写"
                  autoSize={{minRows: 5}}
                  onChange={(e) => this.setState({remark: e.target.value})}/>
                <div style={{margin: "20px auto", textAlign: "center"}}>
                  <Button
                    type="primary"
                    size="large"
                    onClick={this.saveReceiverInfo}
                    loading={saveLoading}
                  >
                    订单预览
                  </Button>
                </div>
              </div>
            ) : null}
          </Fragment>
        )}

        {
          inputType === 4 && (
            <div style={{margin: "20px auto", textAlign: "center"}}>
              <Button
                type="primary"
                size="large"
                onClick={this.savePddReceiverInfo}
                loading={saveLoading}
              >
                订单预览
              </Button>
            </div>
          )
        }

        <Modal
          width={350}
          open={isShowAuth}
          onOk={this.toAuth}
          okText="去实名"
          onCancel={(_) => this.setState({ isShowAuth: false })}>
          <div>
            <div>
              <div style={{ fontSize: 16}}>
                请先完成实名认证
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          width={500}
          title="禁发地区"
          open={isShowOver}
          onCancel={this.overBtnClick}
          onOk={this.overBtnClick}
          footer={[
            <Button key="submit" type="primary" onClick={this.overBtnClick}>
             知道了
            </Button>,
          ]}>

          <div>
            <div>
              <div style={{ width:400,minHeight:150,fontSize: 16}}>
                <div style={{marginBottom:20}}>
                    <Search
                      value={isOverValue}
                      placeholder="输入查询禁发地区"
                      enterButton="搜索"
                      // size="small"
                      onChange={this.handleSearchChange}
                      onSearch={this.onSearchOver}
                   />
                </div>
                <Spin spinning={overLoading}>
                  <div>{overAt}</div>
                </Spin>
              </div>
            </div>
          </div>
        </Modal>

        <Modal 
          open={isModalOpen} 
          onCancel={(_) => this.setState({ isModalOpen: false })}
          width={800}
          title="系统检测到有更近的发货地址，点击商品名可跳转新下单窗口"
          footer={[
            <Button key="submit" type="primary" onClick={this.getReceiverTwoInfo}>
                跳过  
            </Button>,          ]}
        >
          <Table
            columns={columnsData}
            dataSource={addressData}
            bordered
            rowKey="id"
            pagination={false}
            scroll={{y:300}}
          />
        </Modal>

        <Modal title="提示" open={isModalLiOpen} onOk={this.handleLiOk} onCancel={(_) => this.setState({ isModalLiOpen: false })} cancelText="修改收货地址" okText="继续创建订单">
          <p>{liMessage}</p>
        </Modal>

        <Modal
          title="提示"
          open={isDyIdModalOpen}
          closable={false}
          footer={[
            <Button key="submit" type="primary" onClick={this.handleDyIdSubmit}>提交</Button>
          ]}
        >
          <div style={{ display: 'flex', alignItems: 'center', fontSize: 16 }}>
            <span style={{ marginRight: 10 }}>店铺id</span>
            <Input style={{ flex: 1 }} placeholder="请输入店铺id" value={dyShopId} onChange={(e) => this.setState({ dyShopId: e.target.value })} />
          </div>
        </Modal>
      </div>
    );
  }
} 
export default withRouter(GoodsInfo);
